<script>
    import BaseButton from "@main/packages/BaseButton";

    export default {
        name: "CertificatesInfo",
        components: { BaseButton },
        props: {
            name: String,
            url: String,
            type: {
                default: "v2",
                type: String,
            },
            size: {
                default: "sm",
                type: String,
            },
        },
        methods: {
            goTo() {
                this.$router.push({ name: "Home", hash: "#catalog" });
            },
        },
    };
</script>

<template>
    <div class="certificates">
        <div class="l-container">
            <h1 class="certificates__title">
                Условия использования подарочного сертификата {{ name }}
            </h1>

            <div class="certificates__box">
                <div class="certificates__wrapper typography-tags">
                    <p class="certificates__center-text">
                        Электронный подарочный сертификат используется для оплаты покупок на
                        сайте
                        {{ url }} и в розничных магазинах Madrobots в Москве, Санкт-Петербурге,
                        Екатеринбурге и Краснодаре.
                    </p>
                    <div class="certificates__row">
                        <div class="certificates__col">
                            <h3>При покупке на сайте:</h3>
                            <ul>
                                <li>Выберите продукты и добавьте их в корзину.</li>
                                <li>
                                    В корзине в поле «Подарочный сертификат» введите код
                                    сертификата.
                                </li>
                                <li>Номинал сертификата будет учтен при оплате.</li>
                            </ul>
                            <p>
                                Если сумма подарочной карты меньше суммы покупки, необходимо
                                будет доплатить разницу. Если номинал сертификата больше суммы
                                заказа, остаток с сертификата поступает на бонусный счет,
                                который отображается в Личном кабинете.
                            </p>
                        </div>
                        <div class="certificates__col">
                            <h3>При покупке в розничном магазине:</h3>
                            <ul>
                                <li>
                                    Назовите продавцу-консультанту номер подарочного
                                    сертификата. Его номинал будет учтен при оплате.
                                </li>
                            </ul>
                            <p>
                                Будьте внимательны, сертификат не может быть использован или
                                заменен, если его данные утеряны или украдены. Подарочный
                                сертификат является предъявительским и не требует удостоверения
                                личности его держателя.
                            </p>
                            <p>
                                Денежный эквивалент номинала или остатка подарочного
                                сертификата не может быть выдан держателю наличными средствами.
                            </p>
                        </div>
                    </div>
                    <p class="certificates__center-text certificates__center-text--footer">
                        Отправитель сертификата может отменить покупку, аннулировать сертификат
                        и вернуть потраченные средства в течение 15 дней
                        <router-link :to="{ name: 'Guarantee' }">
                            согласно правилам сайта
                        </router-link>
                        — при условии, что сертификат не был использован. <br />Срок действия
                        подарочного сертификата — 365 дней с момента получения.
                    </p>
                </div>
                <div class="certificates__control">
                    <base-button
                        class="certificates__btn"
                        :variant="type"
                        :size="size"
                        @click="goTo"
                    >
                        К покупкам
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .certificates {
        padding-top: 32px;

        @include bp($bp-desktop-sm) {
            padding-top: 56px;
        }
    }

    .certificates__title {
        max-width: 1022px;
        font-weight: bold;
        font-size: 32px;
        color: var(--primary-text);
        margin: 0 auto 32px;

        @include bp($bp-desktop-sm) {
            font-size: 48px;
            margin-bottom: 56px;
            text-align: center;
        }
    }

    .certificates__box {
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0 0 30px #f2f2f5;
        padding: 20px;
        margin-bottom: 100px;

        @include bp($bp-desktop-sm) {
            box-shadow: 0 0 70px #f2f2f5;
            border-radius: 20px;
            padding: 56px 64px;
            margin-bottom: 112px;
        }
    }

    .certificates__center-text {
        max-width: 968px;
        margin: 0 auto 20px !important;

        @include bp($bp-desktop-sm) {
            text-align: center;
            margin-bottom: 32px !important;
        }

        a {
            &:hover {
                text-decoration: underline;
            }
        }

        br {
            display: none;

            @include bp($bp-desktop-sm) {
                display: block;
            }
        }
    }

    .certificates__row {
        margin-bottom: 8px;
        @include bp($bp-tablet-md) {
            display: flex;
            margin-bottom: 16px;
        }
    }

    .certificates__col {
        @include bp($bp-tablet-md) {
            width: 50%;

            &:nth-child(1) {
                padding-right: 32px;
            }
        }

        h3 {
            margin-bottom: 10px;
        }
    }

    .certificates__control {
        margin-top: 24px;

        @include bp($bp-tablet-md) {
            margin-top: 32px;
        }
    }

    .certificates__btn {
        margin: 0 auto;
        width: 100%;

        @include bp($bp-tablet-md) {
            width: 230px;
        }
    }

    .certificates__center-text--footer {
        max-width: 1009px;
    }
</style>
